import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Services from '../components/maketApp/site/Services'


import Footer from '../components/maketApp/site/Footer'
import Contact from '../components/maketApp/site/Contact'
import HerosServices from '../components/maketApp/site/HerosServices'

const ServicePages = () => {
  return (
    <div>
       <Navbar />
       <HerosServices />
       <Services />
         <Footer />
    </div>
  )
}

export default ServicePages
